import { useLayoutEffect } from 'react';

let lockDepth = 0;

const savedHtml = {
  overflow: '',
  overscrollBehavior: '',
};

const savedBody = {
  overflow: '',
  overscrollBehavior: '',
};

function applyLock() {
  const html = document.documentElement;
  const { style: hs } = html;
  const { style: bs } = document.body;

  savedHtml.overflow = hs.overflow;
  savedHtml.overscrollBehavior = hs.overscrollBehavior;
  savedBody.overflow = bs.overflow;
  savedBody.overscrollBehavior = bs.overscrollBehavior;

  hs.overflow = 'hidden';
  hs.overscrollBehavior = 'none';
  bs.overflow = 'hidden';
  bs.overscrollBehavior = 'none';
}

function releaseLock() {
  const html = document.documentElement;
  const { style: hs } = html;
  const { style: bs } = document.body;

  hs.overflow = savedHtml.overflow;
  hs.overscrollBehavior = savedHtml.overscrollBehavior;
  bs.overflow = savedBody.overflow;
  bs.overscrollBehavior = savedBody.overscrollBehavior;
}

/**
 * Freeze document scrolling (nested-safe). Uses overflow on html/body only —
 * avoids position:fixed + negative top, which breaks the frozen frame behind
 * the page behind a native dialog (white html / wrong scroll slice).
 */
export function useBodyScrollLock(active) {
  useLayoutEffect(() => {
    if (!active) return;
    lockDepth += 1;
    if (lockDepth === 1) {
      applyLock();
    }
    return () => {
      lockDepth -= 1;
      if (lockDepth === 0) {
        releaseLock();
      }
    };
  }, [active]);
}
